import SortingOption from 'src/data/api/common/SortingOption';
import {TableColumnSorting} from 'src/view/components/table/table/Types';

export default function tableSortingToSortingOptionMapper(
    tableSorting: TableColumnSorting
): SortingOption {
    return {property: tableSorting.column, direction: tableSorting.direction ?? undefined};
}
